"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>svgs_VipLogo
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const VipLogo = ({ width, height })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("title", {
                children: "VIP Logo"
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                        fill: "#0068ef",
                        d: "M40 20c0 11.045-8.954 20-20 20C8.955 40 0 31.045 0 20 0 8.954 8.955 0 20 0c11.046 0 20 8.954 20 20"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                        fill: "#FFF100",
                        d: "M32.78 15.195c2.576 2.03 2.786 5.38 1.49 7.613-1.273 2.19-3.695 3.352-6.166 2.905-.534-.097-1.038-.366-1.554-.562-.095-.036-.181-.1-.318-.178v4.278c0 .331-.006.337-.343.337-.758 0-1.516-.008-2.274.004-.245.005-.318-.081-.317-.321.004-4.892.004-9.785 0-14.677 0-.224.067-.302.301-.312.844-.034 1.56.22 2.112.892.52-.455 1.072-.821 1.717-1.002 1.951-.547 3.75-.24 5.353 1.023zm-19.083-.911c.847.01 1.693.003 2.539.005.32 0 .375.087.244.386-1.492 3.393-2.986 6.782-4.475 10.176-.246.563-.694.77-1.266.767-.575-.002-1.005-.223-1.252-.788-1.48-3.387-2.973-6.769-4.462-10.152-.137-.311-.085-.389.261-.39.68 0 1.358.008 2.037-.002.512-.008.839.222 1.042.69.728 1.68 1.469 3.354 2.205 5.03.053.12.11.237.181.392.333-.752.65-1.467.965-2.183a839.898 839.898 0 001.608-3.677c.075-.172.17-.258.373-.254zm6.692 0c.239-.003.327.074.327.318-.005 3.51-.005 7.018-.001 10.527.001.23-.084.309-.31.307-.767-.01-1.534-.004-2.301-.005-.332 0-.344-.012-.344-.34V14.643c0-.351.003-.354.355-.354.758-.002 1.516.006 2.274-.005zm8.687 2.563a3.007 3.007 0 00-3.008 3.01 3.002 3.002 0 003 3.015 2.99 2.99 0 003.029-3.007 2.996 2.996 0 00-3.02-3.018z"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("path", {
                        d: "M0 0h40v40H0z"
                    })
                ]
            })
        ]
    });
const svgs_VipLogo = VipLogo;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
